export default "__VITE_ASSET__DzS4W4SN__"